import { render, staticRenderFns } from "./HomeArticleEn.vue?vue&type=template&id=5aa5711a"
import script from "./HomeArticleEn.vue?vue&type=script&lang=js"
export * from "./HomeArticleEn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports